import Icons from './Icons';
import type Car from '../../models/Car';

// eslint-disable-next-line react-refresh/only-export-components
export  const formatCurrency = (amount: number) => 
    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);

const CalendarGlyph = () => (
    <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3M4 11h16M5 5h14a1 1 0 011 1v14a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1z" />
    </svg>
);

interface CarCardProps {
    car: Car;
    onViewDetails?: () => void;
    onRequestAppointment?: () => void;
}

const CarCard = ({ car, onViewDetails, onRequestAppointment }: CarCardProps) => {
    const imageSrc = car.images && car.images.length > 0 ? car.images[0] : null;

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition flex flex-col">
            <div className="h-48 bg-gray-200 relative">
                {imageSrc ? (
                    <img src={imageSrc} alt={`${car.make} ${car.model}`} className="w-full h-full object-cover" />
                ) : (
                    <div className="absolute inset-0 flex items-center justify-center text-gray-400">
                        <Icons.Car />
                    </div>
                )}
                {onRequestAppointment && (
                    <button
                        type="button"
                        onClick={onRequestAppointment}
                        className="absolute right-3 top-3 inline-flex items-center gap-2 rounded-full bg-white/95 px-3 py-2 text-[10px] font-black uppercase tracking-widest text-gray-900 shadow-lg ring-1 ring-gray-200 transition hover:bg-red-600 hover:text-white"
                        aria-label={`Request appointment for ${car.year} ${car.make} ${car.model}`}
                        title="Request appointment"
                    >
                        <CalendarGlyph />
                        <span className="hidden sm:inline">Schedule</span>
                    </button>
                )}
            </div>
            <div className="p-4 flex flex-col flex-grow">
                <h3 className="text-lg font-bold text-gray-900 leading-tight mb-1">{car.year} {car.make} {car.model}</h3>
                <p className="text-sm text-gray-500 mb-4">{car.mileage} miles</p>
                <div className="mt-auto flex justify-between items-center">
                    <span className="text-xl font-bold text-red-600">{formatCurrency(car.price)}</span>
                    <button onClick={onViewDetails} className="text-sm font-bold text-gray-700 bg-gray-100 hover:bg-gray-200 py-1 px-3 rounded">Details</button>
                </div>
            </div>
        </div>
    );
}


export default CarCard;
